(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalCheckbox', ['$compile', RfGlobalCheckboxFn]);

    /* directive for checkbox */
    function RfGlobalCheckboxFn($compile) {

        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;

        function randstr(prefix) {
            return Math.random().toString(36).replace('0.', prefix || '');
        }

        function link(scope, element, attrs) {
            element.addClass("mt-checkbox smaller_checkbox");

            var id = randstr('checkbox_');

            var input = '<input type="checkbox" id="' + id + '" ';

            if (typeof attrs.model !== 'undefined') {
                input += 'ng-model="' + attrs.model + '" ';
            }
            if (typeof attrs.changeFn !== 'undefined') {
                input += 'ng-change="' + attrs.changeFn + '" ';
            }
            if (typeof attrs.clickFn !== 'undefined') {
                input += 'ng-click="' + attrs.clickFn + '" ';
            }

            // disabled ?
            if (typeof attrs.disabled !== 'undefined') {
                input += 'ng-disabled="' + attrs.disabled + '" ';
            } // if

            input += '/>';
            element.append($compile(input)(scope));

            // label
            var label = '<label for="' + id + '" ';
            if (typeof attrs.label !== 'undefined') {

                label += 'translate="' + attrs.label + '" ';
                if (typeof attrs.translateValues !== 'undefined') {
                    label += ' translate-values="' + attrs.translateValues + '"';
                } // if                
            } // if
            label += '></label>';

            element.append($compile(label)(scope));

            element.append("<span></span>");

        }

    }

})();